<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" @click="openModel('hyxl')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table
				:data="hyxlList"
				style="width: 100%"
				size="mini"
				row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
				@current-change="handleCurrentChange"
				:max-height="maxHeight"
			>
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						名称
					</template>
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
				<el-table-column width="160">
					<template slot="header" slot-scope="scope">
						创建时间
					</template>
					<template slot-scope="scope">
						{{ scope.row.create_time }}
					</template>
				</el-table-column>

				<el-table-column align="center" width="190">
					<template slot="header" slot-scope="scope">
						操作
					</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="openModel('hyxl', scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-form v-if="preUrl === 'hyxl'" ref="form" :model="form.hyxl" label-width="80px">
					<el-form-item label="名称"><el-input v-model="form.hyxl.name" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="联系人"><el-input v-model="form.hyxl.zd_lxr" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="电话"><el-input v-model="form.hyxl.zd_phone" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="地址"><el-input v-model="form.hyxl.zd_dz" size="mini" style="width: 95%;"></el-input></el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				hyxl: {}
			},
			createModel: false,
			dialogType: 'hyxl',
			preUrl: 'hyxl', //api
			dialogId: 0,
			hyxlList: [],
			maxHeight: 0,
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`;
		},
		// 处理列表结果
		getListResult(e) {
			this.hyxlList = e.list;
			console.log(this.hyxlList);
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'hyxl':
					if (!item) {
						this.form.hyxl = {
							id: '',
							name: '',
							zd_lxr: '',
							zd_phone: '',
							zd_dz: ''
						};
						this.dialogId = 0;
					} else {
						this.form.hyxl = {
							name: item.name,
							zd_lxr: item.zd_lxr,
							zd_phone: item.zd_phone,
							zd_dz: item.zd_dz
						};
						this.dialogId = item.id;
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.hyxl;
			let e = {
				name: f.name,
				zd_lxr: f.zd_lxr,
				zd_phone: f.zd_phone,
				zd_dz: f.zd_dz,
				cjr: this.user.id
			};
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
